// NPM Imports
import React from "react";

// Component Imports
import ContentLock from "./ContentLock";
import ContentLockUpgrade from "./ContentLockUpgrade";
import { FeatureGating } from "../../../commonComponents";

// Internal Imports
import { FEATURES } from "../../../constants";

// Destructuring
const { FEATURES_NAME } = FEATURES;

export default function (props) {
  return (
    <FeatureGating
      name={FEATURES_NAME.DOCUMENTS_CONTENT_LOCKING}
      altComponent={
        <ContentLockUpgrade toggleUpgradePopup={props.toggleUpgradePopup} />
      }>
      <ContentLock {...props} />
    </FeatureGating>
  );
}
